export enum EItemTransferringStage {
  ITS_NONE,
  ITS_UNLOAD,
  ITS_LOAD,
}
